import React from 'react';
import { Button } from '@appkit4/react-components/button';

interface ButtonLoadSubmitProps {
    name: string;
    loading?: boolean;
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
    icon?: string;  // Optional icon prop to allow custom icons
    disabled?: boolean;
    kind?: 'primary' | 'secondary' | 'tertiary' | 'negative' | 'text';
}

const ButtonLoadSubmit: React.FC<ButtonLoadSubmitProps> = ({
    name,
    loading,
    onClick,
    className,
    style,
    icon = "icon-time-outline",  // Default icon is now set here
    disabled,
    kind = 'primary'
}) => {
    // Determine the icon to display: either loading icon or specified/default icon
    const buttonIcon = loading ? "icon-loading" : icon;

    return (
        <Button
            kind={kind}
            type="button"
            icon={buttonIcon}  // Use the dynamically determined icon
            onClick={onClick}
            disabled={disabled || loading}
            className={className}
            style={style}
        >
            {loading ? 'Converting...' : name}
        </Button>
    );
};

export default ButtonLoadSubmit;
